module.exports = __webpack_public_path__ + "img/2pic.a90dec5a.png";